/*
  Phatstix WAITLIST — bespoke form, posted straight to Klaviyo's public client endpoint.

  Replaces Klaviyo's onsite forms entirely (Thom's call: he does not want their form markup on the
  site). The POST is in assets/ph-klaviyo.js, shared with the Clippy 10% capture, so the endpoint,
  the revision header and the body shape exist in exactly one place.

  Triggers: any element with [data-ph-waitlist]. Optional data attributes read off the trigger:
    data-product   product title, shown in the modal copy
    data-variant-id variant id, stored as a profile property so a flow can segment on it
    data-href      fallback URL if the modal or the config is missing
    data-prefill-from  CSS selector for an input whose value pre-fills the modal's email field.
                   Used by the inline waitlist panel on the tint PDPs (ph-pdp-buybox 'waitlist'
                   block) so a shopper who has already typed their address is not asked twice.

  Graceful degradation: if the company id or list id is not set in Theme settings, we do not show a
  broken form, we navigate to data-href instead (the old behaviour).
*/
(function () {
  'use strict';

  var modal = document.querySelector('[data-ph-waitlist-modal]');
  if (!modal) return;

  var company = (modal.getAttribute('data-company') || '').trim();
  var listId = (modal.getAttribute('data-list') || '').trim();
  var win = modal.querySelector('.ph-wl__win');
  var form = modal.querySelector('[data-ph-wl-form]');
  var input = modal.querySelector('#ph-wl-email');
  var errEl = modal.querySelector('[data-ph-wl-error]');
  var nameEl = modal.querySelector('[data-ph-wl-product]');
  var lastTrigger = null;
  var current = { product: '', variantId: '' };

  function show(state) {
    var all = modal.querySelectorAll('[data-ph-wl-state]');
    for (var i = 0; i < all.length; i++) {
      all[i].hidden = all[i].getAttribute('data-ph-wl-state') !== state;
    }
  }

  function open(trigger) {
    lastTrigger = trigger || null;
    current.product = (trigger && trigger.getAttribute('data-product')) || '';
    current.variantId = (trigger && trigger.getAttribute('data-variant-id')) || '';
    // The product name is now the EYEBROW above the headline (item 75), not a phrase inside a
    // sentence, so there is no wording for it to fall back to: a trigger with no data-product
    // hides the row rather than printing "this one" as a heading. .ph-wl__eyebrow[hidden] is
    // declared in ph-waitlist.css because the element sets display:block.
    if (nameEl) {
      nameEl.textContent = current.product;
      nameEl.hidden = !current.product;
    }
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    // PREFILL. An inline panel (the tint PDP buy box) hands over the address already typed there,
    // so opening the modal does not ask for it twice. data-prefill-from is a CSS selector for that
    // field. Missing attribute, bad selector, no match or an empty value all fall through to a
    // blank input, which is exactly the old behaviour - so every existing trigger is unaffected.
    var typed = '';
    if (trigger) {
      var sel = trigger.getAttribute('data-prefill-from');
      if (sel) {
        var src = null;
        try { src = document.querySelector(sel); } catch (e) { src = null; }
        if (src && src.value) typed = src.value.trim();
      }
    }
    if (input) input.value = typed;
    show('idle');
    modal.hidden = false;
    document.documentElement.classList.add('ph-wl-open');
    // focus after paint so the transition does not eat it
    requestAnimationFrame(function () {
      if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
      else if (win) win.focus();
    });
  }

  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('ph-wl-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  function fail(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.hidden = false;
  }

  // The POST itself now lives in assets/ph-klaviyo.js, shared with the Clippy capture. Only the
  // source label and the profile properties are ours.
  function subscribe(email) {
    return window.phKlaviyo.subscribe({
      company: company,
      listId: listId,
      email: email,
      source: 'Phatstix site waitlist',
      properties: {
        waitlist_product: current.product || null,
        waitlist_variant_id: current.variantId || null
      }
    });
  }

  // ---- open, from any trigger anywhere on the page (capture, so card links never win) ----
  document.addEventListener(
    'click',
    function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-ph-waitlist]') : null;
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      if (!company || !listId) {
        var href = el.getAttribute('data-href');
        if (href) window.location.href = href;
        return;
      }
      open(el);
    },
    true
  );

  // ---- close ----
  modal.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-ph-wl-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  var retry = modal.querySelector('[data-ph-wl-retry]');
  if (retry) retry.addEventListener('click', function () { show('idle'); if (input) input.focus(); });

  // ---- submit ----
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input && input.value ? input.value : '').trim();
      // deliberately loose: Klaviyo validates properly server-side, and an over-strict regex
      // rejects valid addresses. We only catch the obvious nonsense.
      if (!email || email.indexOf('@') < 1 || email.indexOf('.', email.indexOf('@')) < 0) {
        fail('That does not look like an email address.');
        if (input) input.focus();
        return;
      }
      if (errEl) errEl.hidden = true;
      show('sending');
      subscribe(email)
        .then(function (res) {
          if (res.status === 202 || res.ok) {
            // Shared flag: Clippy reads this and stays away from someone who has already given us
            // an address. Whichever form runs first sets it.
            window.phKlaviyo.markCaptured();
            show('done');
          }
          else { show('failed'); }
        })
        .catch(function () { show('failed'); });
    });
  }
})();
